import { render, staticRenderFns } from "./SchoolSearchBar.vue?vue&type=template&id=c16a5b6a&scoped=true&"
import script from "./SchoolSearchBar.vue?vue&type=script&lang=js&"
export * from "./SchoolSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSearchBar.vue?vue&type=style&index=0&id=c16a5b6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16a5b6a",
  null
  
)

export default component.exports